import { createGlobalStyle } from "styled-components";

const styled = { createGlobalStyle };

const GlobalStyles = styled.createGlobalStyle`
  :root {
    &.light-mode {
      /* Grey */
      --color-bg: #d3d0cc;
      --color-grey-main: #f3f5f6;
      --color-grey-0: #fff;
      --color-grey-50: #f9fafb;
      --color-grey-100: #f3f4f6;
      --color-grey-200: #e5e7eb;
      --color-grey-300: #d1d5db;
      --color-grey-400: #9ca3af;
      --color-grey-500: #6b7280;
      --color-grey-600: #4b5563;
      --color-grey-700: #374151;
      --color-grey-800: #1f2937;
      --color-grey-900: #111827;

      --color-blue-100: #e0f2fe;
      --color-blue-700: #0369a1;
      --color-green-100: #dcfce7;
      --color-green-700: #15803d;
      --color-yellow-100: #fef9c3;
      --color-yellow-700: #a16207;
      --color-silver-100: #e5e7eb;
      --color-silver-700: #374151;
      --color-indigo-100: #e0e7ff;
      --color-indigo-700: #4338ca;

      --color-red-100: #fee2e2;
      --color-red-700: #b91c1c;
      --color-red-800: #991b1b;

      --backdrop-color: rgba(255, 255, 255, 0.1);
      --backdrop-color-modal: rgba(255, 255, 255, 0.4);
      --backdrop-color-ex: rgba(200, 200, 255, 0.3);
      --backdrop-color-op: rgba(30, 30, 30);

      --shadow-main:
        -7px -7px 30px 0px #f3f5f6, 14px 14px 40px 0px rgba(16, 16, 18, 0.75);
      --shadow-div-md:
        -4px -4px 10px 0px #f3f5f6, 9px 9px 9px 0px rgba(16, 16, 18, 0.45);
      --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.04);
      --shadow-md: 0px 0.6rem 2.4rem rgba(0, 0, 0, 0.06);
      --shadow-lg: 0 2.4rem 3.2rem rgba(0, 0, 0, 0.12);
      --shadow-btn: 4px 4px 8px #c5c5c5, -4px -4px 8px #ffffff;
      --shadow-btn-active:
        inset 3px 3px 8px #c5c5c5, inset -3px -3px 8px #ffffff;
      --shadow-btn-round:
        0 15px 25px -4px rgba(0, 0, 0, 0.5),
        inset 0 -3px 4px -1px rgba(0, 0, 0, 0.2),
        0 -10px 15px -1px rgba(255, 255, 255, 0.6),
        inset 0 3px 4px -1px rgba(255, 255, 255, 0.2),
        inset 0 0 5px 1px rgba(255, 255, 255, 0.8),
        inset 0 20px 30px 0 rgba(255, 255, 255, 0.2);

      --image-grayscale: 0;
      --image-opacity: 100%;
    }
    &,
    &.dark-mode {
      --color-bg: #2c2f33;
      --color-grey-main: #262e32;
      --color-grey-0: #18212f;
      --color-grey-50: #111827;
      --color-grey-100: #1f2937;
      --color-grey-200: #374151;
      --color-grey-300: #4b5563;
      --color-grey-400: #6b7280;
      --color-grey-500: #9ca3af;
      --color-grey-600: #d1d5db;
      --color-grey-700: #e5e7eb;
      --color-grey-800: #f3f4f6;
      --color-grey-900: #f9fafb;

      --color-blue-100: #075985;
      --color-blue-700: #e0f2fe;
      --color-green-100: #166534;
      --color-green-700: #dcfce7;
      --color-yellow-100: #854d0e;
      --color-yellow-700: #fef9c3;
      --color-silver-100: #374151;
      --color-silver-700: #f3f4f6;
      --color-indigo-100: #3730a3;
      --color-indigo-700: #e0e7ff;

      --color-red-100: #fee2e2;
      --color-red-700: #b91c1c;
      --color-red-800: #991b1b;

      --backdrop-color: rgba(0, 0, 0, 0.3);
      --backdrop-color-modal: rgba(0, 0, 15, 0.25);
      --backdrop-color-ex: rgba(0, 0, 50, 0.4);

      --shadow-main:
        -7px -7px 30px 0px #262e32, 14px 14px 40px 0px rgba(16, 16, 18, 0.75);
      --shadow-div-md:
        -4px -4px 10px 0px #262e32, 9px 9px 9px 0px rgba(16, 16, 18, 0.75);
      --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
      --shadow-md: 0px 0.6rem 2.4rem rgba(0, 0, 0, 0.3);
      --shadow-lg: 0 2.4rem 3.2rem rgba(0, 0, 0, 0.4);
      --shadow-btn: 4px 4px 8px #1a1919, -4px -4px 8px #2f2f2f;
      --shadow-btn-active: inset 3px 3px 8px #000, inset -3px -3px 8px #1f1f1f;
      --shadow-btn-round:
        0 15px 25px -4px rgba(0, 0, 0, 0.5),
        inset 0 -3px 4px -1px rgba(0, 0, 0, 0.2),
        0 -10px 15px -1px rgba(0, 0, 0, 0.6),
        inset 0 3px 4px -1px rgba(0, 0, 0, 0.2),
        inset 0 0 5px 1px rgba(0, 0, 0, 0.3),
        inset 0 20px 30px 0 rgba(0, 0, 0, 0.2);
      --image-grayscale: 10%;
      --image-opacity: 90%;
    }

    /* Chart Colors */
    /* Crane height category colors */
    --crane-height-low: #d8cd8d; 
    --crane-height-md: #a0c9a3; 
    --crane-height-hi: #8dc2d3; 
    --crane-height-top: #c972d1; 

    /* Capacity / reference line styling */
    --dispatch-capacity-opacity: 0.45;
    --dispatch-capacity-dash: 5 8;

    /* Dashboard semantic status colors */
    --status-ok: #67cf8d;
    --status-info: #4ea3df;
    --status-warning: #f59e0b;
    --status-alarm: #ef4444;
    --status-neutral: #94a3b8;

    /* Indigo */
    --color-brand-50: #eef2ff;
    --color-brand-100: #e0e7ff;
    --color-brand-200: #c7d2fe;
    --color-brand-500: #6366f1;
    --color-brand-600: #4f46e5;
    --color-brand-700: #4338ca;
    --color-brand-800: #3730a3;
    --color-brand-900: #312e81;

    --color-witron-blue: #0e64cb;
    --color-witron-grey: #939598;

    --border-radius-tiny: 3px;
    --border-radius-sm: 5px;
    --border-radius-md: 7px;
    --border-radius-lg: 9px;

    /* For dark mode */
    --image-grayscale: 0;
    --image-opacity: 100%;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    padding: 0;
    margin: 0;

    /* Creating animations for dark mode */
    transition:
      background-color 0.3s,
      border 0.3s;
  }

  html {
    font-size: 62.5%;
  }

  body {
    font-family: "Nunito", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--color-grey-700);
    background-color: var(--color-bg);
    transition:
      color 0.3s,
      background-color 0.3s;
    min-height: 100vh;
    line-height: 1.5;
    font-size: 1.6rem;
    font-weight: 500;

    @media (max-width: 1440px) {
      font-weight: 400; /* Reduced by 100 */
    }
  }

  em {
    font-family: "Nunito Italic", "Nunito", sans-serif;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
    color: inherit;
  }

  button {
    cursor: pointer;
  }

  *:disabled {
    cursor: not-allowed;
  }

  select:disabled,
  input:disabled {
    background-color: var(--color-grey-200);
    color: var(--color-grey-500);
  }

  input:focus,
  button:focus,
  textarea:focus,
  select:focus {
    outline: 0.2px solid var(--color-grey-200);
    outline-offset: -1px;
  }

  /* Parent selector, finally 😃 */
  button:has(svg) {
    line-height: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
    hyphens: auto;
  }

  img {
    max-width: 100%;

    /* For dark mode */
    filter: grayscale(var(--image-grayscale)) opacity(var(--image-opacity));
  }

  /* Keyframes for moving borders */
  @keyframes movingBorders {
    0%,
    90% {
      border-color: #fce4e4;
    }
    50% {
      border-color: #ffd8d8;
    }
  }

  /* Keyframes for beating heart */
  @keyframes beatingHeart {
    0%,
    30%,
    60% {
      transform: scale(1);
    }
    15%,
    45% {
      transform: scale(1.15);
    }
  }

  *::-webkit-scrollbar {
    width: 4px; /* Adjust the width of the scrollbar */
  }

  *::-webkit-scrollbar-track {
    background-color: transparent; /* Make the track invisible */
  }

  *::-webkit-scrollbar-thumb {
    scroll-behavior: smooth;
    background: var(--color-witron-blue); // Style the thumb
    border-radius: 4px;
    border: 1px solid transparent; /* Invisible border; needed for some browsers to avoid default styles */
    background-clip: padding-box; /* Prevents the background color from spilling into the border area */
  }

  /* Styles for Firefox */
  * {
    scrollbar-width: thin; /* Can be "auto", "thin", or "none" */
    scrollbar-color: var(--color-witron-blue) transparent; /* Style the thumb and make the track invisible */
  }
`;

export default GlobalStyles;
